import { React, useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Link, Routes } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Navigation from "../../Components/Nav/Navigation";
import sidebarBackgound from "../../assets/background/log-in-background.jpg";
import Track from "../../Images/track.svg";
import { UniqueIdContext } from "../../FinContext";
import { useTranslation } from "react-i18next";
import { persistor } from "../../Redux/store";
import {
    RESET_ALL_STATES,
    setAuthenticated,
} from "../../Redux/actions/actions";
import {
    svgIcon1,
    svgIcon2,
    svgIcon3,
    svgIcon4,
    svgIcon5,
    svgIcon6,
    svgIcon7,
} from "./svgIcon";
import { locationThunk } from "../../Redux/thunks/locationThunk";
import logo from "../../assets/logos/logo_only.png";
import {
    IoMdHelp,
    IoMdHome,
    IoMdLogOut,
    IoMdNotifications,
} from "react-icons/io";
import Footer from "../../Components/Footer/footer";
import { Popover } from "antd";
import NavBar from "../../Components/Nav/newNavBar";
import { cardProcessorDataThunk } from "../../Redux/thunks/cardProcessorDataThunk";
import Notification from "../../Components/Nav/Notification";
import { getUpdateRequest } from "../../Redux/thunks/getUpdateRequest";
import { FaBell } from "react-icons/fa";
import apiClient from "../../utils/apiClient";

const service = [
    {
        id: 1,
        Icon: svgIcon1,
        HoverIcon: Track,
        title: "dashboard-card1-title",
        description: "dashboard-card1-desc",
        path: "/updatedemo",
        status: "new",
    },
    {
        id: 2,
        Icon: svgIcon1,
        HoverIcon: Track,
        title: "dashboard-card1-title-correct",
        description: "dashboard-card1-desc-correct",
        path: "/correctdemo",
        status: "new",
    },
    {
        id: 3,
        Icon: svgIcon2,
        HoverIcon: Track,
        title: "dashboard-card2-title",
        description: "dashboard-card2-desc",
        path: "/status",
        status: "new",
    },
    {
        id: 4,
        Icon: svgIcon3,
        HoverIcon: Track,
        title: "dashboard-card3-title",
        description: "dashboard-card3-desc",
        path: "/construction",
        status: "inactive",
        bannerText: "Coming Soon",
    },
    // {
    //     id: 5,
    //     Icon: svgIcon4,
    //     HoverIcon: Track,
    //     title: "dashboard-card4-title",
    //     description: "dashboard-card4-desc",
    //     path: "/PrintableCredential",
    //     status: "new",
    // },
    {
        id: 6,
        Icon: svgIcon5,
        HoverIcon: Track,
        title: "dashboard-card5-title",
        description: "dashboard-card5-desc",
        path: "/construction",
        status: "inactive",
        bannerText: "Coming Soon",
    },
    {
        id: 7,
        Icon: svgIcon6,
        HoverIcon: Track,
        title: "dashboard-card6-title",
        description: "dashboard-card6-desc",
        path: "/construction",
        status: "inactive",
        bannerText: "Coming Soon",
    },
    {
        id: 8,
        Icon: svgIcon7,
        title: "dashboard-card7-title",
        description: "dashboard-card7-desc",
        path: "/construction",
        status: "inactive",
        bannerText: "Coming Soon",
    },
];

const ServiceCard = ({
    Icon,
    HoverIcon,
    title,
    description,
    path,
    status,
    bannerText,
    blur
}) => (
    <Link
        to={path}
        className='relative p-10 no-underline text-inherit bg-white rounded-md shadow-md  shadow-gray-8  font-barlow group'
        onClick={(e) => {
            if (!blur && title === "Download Printable Credential") {
                e.preventDefault();
            }
        }}
    >

        {!blur && title === "Download Printable Credential" && (
        <div className="absolute top-2 right-2">
            <div className="w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin" />
        </div>
        )}

        <div className='w-full flex justify-center'>
            <div className='h-full max-h-[70px] flex w-full max-w-[150px]'>
                {Icon}
            </div>
        </div>
        <h3 className='mb-1 text-sm text-MetallicBlue  font-medium text-center md:text-xl'>
            {title}
        </h3>
        <p className='px-1 text-xs text-center text- bg- md:text-sm md:px-0 tracking- text-MetallicBlue '>
            {description}
        </p>
    </Link>
);

const Services = () => {
    const isAuthenticated = useSelector(
        (state) => state.session.isAuthenticated
    )
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();
    // const locationData = useSelector((state) => state.location);
    const pdfData = useSelector((state) => state.pdfData);
    const dtoData = useSelector((state) => state.otp.data);

    // const verify = useSelector((state) => state.verify);
    // const isAuthenticated = verify?.data === null ? false : true;

    useEffect(() => {
        if (isAuthenticated) {
            dispatch(setAuthenticated());
            navigate("/dashboard");
            // if (locationData?.data === null) {
            //     dispatch(locationThunk());
            // }
            if (pdfData?.data === null) {
                dispatch(cardProcessorDataThunk(dtoData.uin, dtoData.signature));
            }
        } else {
            navigate("/");
        }
    }, [navigate, dispatch, isAuthenticated]);
    const [open, setOpen] = useState(false);
    const [openNotification, setOpenNotification] = useState(false);
    const { i18n } = useTranslation();

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };

    const handleOpenChange = (newOpen) => {
        setOpen(newOpen);
    };

    const handleFetchClick = async () => {
        await dispatch(getUpdateRequest(dtoData.uin));
    };

    const handleNotificationOpen = (newOpen) => {
        setOpenNotification(newOpen);
        if (newOpen) {
            handleFetchClick();
        }
    };

    const logoutUser = () => {
        dispatch({ type: "LOGOUT" });
        dispatch({ type: RESET_ALL_STATES });
        persistor.purge();
        navigate("/");
    };

    return (
        <div className='flex h-screen w-full'>
            <div className='bg-top bg-no-repeat bg-cover hidden md:flex flex-col justify-between md:pt-44 pt-10 pb-20 top-0 bg-dashboard-sidebar'>
                <div className='flex flex-col w-full gap-5 capitalize text-white'>
                    <Link
                        to='/dashboard'
                        className='flex items-center gap-1 py-2 px-8     hover:bg-MetallicBlue/80'
                    >
                        <IoMdHome size={32} />
                        <span className='text-xl'>{t("home")}</span>
                    </Link>

                    <Popover
                        overlayInnerStyle={{ color: "#000" }}
                        content={<Notification />}
                        open={openNotification}
                        onOpenChange={handleNotificationOpen}
                        placement='right'
                    >
                        <button className='flex items-center gap-1 py-2 px-8 hover:bg-MetallicBlue/80'>
                            <FaBell size={27} />
                            <span className='text-xl'>{t("notification")}</span>
                        </button>
                    </Popover>

                    <a
                        href='https://id.et/faq'
                        className='flex items-center gap-1 py-2 px-8 hover:bg-MetallicBlue/80'
                    >
                        <IoMdHelp size={32} />
                        <span className='text-xl'>{t("help")}</span>
                    </a>
                </div>

                <div className='flex flex-col w-full gap-2 capitalize text-white'>
                    <Popover
                        overlayInnerStyle={{ color: "#000" }}
                        content={
                            <div className='flex flex-col gap-2 w-[100px]'>
                                <button
                                    className='w-full bg-MetallicBlue text-white text-md rounded-md py-1'
                                    onClick={() => changeLanguage("en")}
                                >
                                    English
                                </button>
                                <button
                                    className='w-full bg-MetallicBlue text-white text-md rounded-md py-1'
                                    onClick={() => changeLanguage("amh")}
                                >
                                    አማርኛ
                                </button>
                            </div>
                        }
                        open={open}
                        onOpenChange={handleOpenChange}
                    >
                        <button className='flex items-center gap-1 py-2 px-8 hover:bg-MetallicBlue/80'>
                            <IoMdHome size={32} />
                            <span className='text-xl'>
                                {" "}
                                {i18n.language === "amh" ? "English" : "አማርኛ"}
                            </span>
                        </button>
                    </Popover>
                    <button
                        className='flex items-center gap-1 py-2 px-8 hover:bg-MetallicBlue/80'
                        onClick={logoutUser}
                    >
                        <IoMdLogOut size={32} />
                        <span className='text-xl'>{t("logout")}</span>
                    </button>
                </div>
            </div>
            <div className='w-full h-screen scrollbar-hide overflow-scroll bg-gray-50 flex flex-col gap-10 md:pt-20'>
                <div className='md:hidden'>
                    <NavBar />
                </div>
                <div className='max-w-[1600px] px-[10%] flex flex-col gap-5 mx-auto'>
                    <p className='text-3xl font-semibold text-MetallicBlue'>
                        {t("home")}
                    </p>
                    <div className='w-full grid md:grid-cols-2 xl:grid-cols-3 gap-10'>
                        {service.map((service) => (
                            <ServiceCard
                                key={service.id}
                                Icon={service.Icon}
                                title={t(service.title)}
                                description={t(service.description)}
                                path={service.path}
                                status={service.status}
                                bannerText={service.bannerText}
                                blur={!!pdfData.data}
                            />
                        ))}
                    </div>
                </div>
                {/* <div className='w-full max-w-[1600px] px-[10%] flex flex-col gap-5 mx-auto'>
                    <p className='text-3xl font-semibold text-MetallicBlue'>
                        Tutorial
                    </p>
                    <div className='w-full rounded-lg h-[200px] gap-10 shadow-md'></div>
                </div> */}
                <Footer />
            </div>
        </div>
    );
};
export default Services;
